import { useCallback, useState } from 'react';

interface ModalState {
  show: boolean;
  data?: any;
}

export type ModalHookResponse = {
  state: ModalState;
  openModal: (data?: any) => void;
  closeModal: () => void;
};

export const useModal = (): ModalHookResponse => {
  const [modalState, setModalState] = useState<ModalState>({
    show: false,
    data: undefined,
  });

  const openModal = useCallback(
    (data?: any) => {
      setModalState({
        show: true,
        data: data,
      });
    },
    [setModalState],
  );

  const closeModal = useCallback(() => {
    setModalState({
      show: false,
      data: undefined,
    });
  }, [setModalState]);

  return {
    state: modalState,
    openModal,
    closeModal,
  };
};
